"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPreview = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

var _molecules = require("../../../molecules");

var _Modal = require("../../../molecules/Modal");

var _NotificationPreviewContent = require("../NotificationPreviewContent");

var _VideoPlayer = require("../../VideoPlayer");

require("./NotificationPreview.css");

var _getTrackingCategory = require("../../../util/getTrackingCategory");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var NotificationPreview = function NotificationPreview(_ref) {
  var notification = _ref.notification,
      item = _ref.item,
      showTooltip = _ref.showTooltip,
      open = _ref.open,
      handleTraceIDClick = _ref.handleTraceIDClick,
      momentAdded = _ref.momentAdded,
      onClose = _ref.onClose,
      onDownload = _ref.onDownload;
  var containerRef = (0, _VideoPlayer.useVideoContainerRef)();

  var _useMetaVideoInfo = (0, _VideoPlayer.useMetaVideoInfo)(containerRef),
      currentMoment = _useMetaVideoInfo.moment,
      paused = _useMetaVideoInfo.paused;

  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    open: open,
    className: "NotificationPreviewPlayer",
    onShadeClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    lg: _atoms.Stack.Type.Row,
    md: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Row,
    xs: _atoms.Stack.Type.Column,
    className: "notification-preview-player-container"
  }, /*#__PURE__*/_react.default.createElement(_Modal.CloseButton, {
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_molecules.ModalVideoPlayer, {
    momentId: item.game_clip_id,
    moments: [item],
    containerRef: containerRef,
    previewMode: true,
    loop: true,
    trackingCategory: (0, _getTrackingCategory.getTrackingCategory)(),
    trackingAction: 'Notifications'
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    widthXS: "100vw",
    widthSM: "260px",
    widthMD: "100%",
    widthLG: "350px",
    spanXS: 6,
    spanMD: 6,
    paddingTopXS: "16",
    paddingTopSM: "8",
    paddingTopMD: "8",
    paddingTopLG: "8",
    paddingLeft: "4",
    paddingRight: "4"
  }, notification && /*#__PURE__*/_react.default.createElement(_NotificationPreviewContent.NotificationPreviewContent, {
    notification: notification,
    currentMoment: currentMoment,
    showTooltip: showTooltip,
    handleTraceIDClick: handleTraceIDClick,
    momentAdded: momentAdded,
    onDownload: onDownload
  }))));
};

exports.NotificationPreview = NotificationPreview;